interface Review {
  name: string;
  rating: number;
  date: string;
  text: string;
  color: string;
  source: 'google' | 'instagram';
}

const reviews: Review[] = [
  {
    name: '田中さおり 様',
    rating: 5,
    date: '2026年2月',
    text: '宇検村ドライブの途中に立ち寄りました。手ごね生地のピザが本当においしい！パリパリで、チーズがとろとろ。また来たい！',
    color: 'bg-tankan/20 text-tankan',
    source: 'google',
  },
  {
    name: '吉村たかし 様',
    rating: 5,
    date: '2026年1月',
    text: '奄美の友人に教えてもらいました。ニンニクと塩豚ピザが最高！窯の前で焼いてくれる様子も楽しかった。宇検村に来たらここです。',
    color: 'bg-kiln/20 text-kiln',
    source: 'google',
  },
  {
    name: 'まいまい♡奄美旅 様',
    rating: 5,
    date: '2025年12月',
    text: 'インスタで見て行ってみました！お店の雰囲気も最高で、ソフトクリームも食べた。靴脱いでくつろげるのがすごくいい。また行きます♡',
    color: 'bg-rose-200 text-rose-500',
    source: 'instagram',
  },
  {
    name: '松本家族旅行 様',
    rating: 5,
    date: '2025年11月',
    text: '子供たちが大喜び！ミックスピザとよもぎ餅を食べました。オーナーさんがとても親切で、宇検村の話もいろいろ聞かせてくれました。',
    color: 'bg-amber-200 text-amber-600',
    source: 'google',
  },
  {
    name: 'Yuki.amami 様',
    rating: 5,
    date: '2025年10月',
    text: '地元民です。できたての熱々ピザを持って湯湾岳に行きました。最高のランチになりました。いつもありがとうございます！',
    color: 'bg-emerald-200 text-emerald-600',
    source: 'instagram',
  },
  {
    name: '石川ひろこ 様',
    rating: 5,
    date: '2025年9月',
    text: 'マルゲリータとジェノベーゼを食べました。生地が絶品！あんなに薄くてパリッとしたピザは初めて。たんかん農家さんが作るってのも素敵。',
    color: 'bg-sky-200 text-sky-500',
    source: 'google',
  },
];

export default function Reviews() {
  return (
    <section className="bg-cream py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-tankan/10 text-tankan text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / REVIEWS
          </span>
          <h2 className="text-3xl md:text-4xl font-rounded font-black text-kiln">
            お客様の声
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-lg" />
              ))}
            </div>
            <span className="text-kiln font-rounded font-black text-2xl">4.8</span>
            <span className="text-kiln/60 font-rounded text-sm">Google 総合評価</span>
          </div>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.name} className="bg-white rounded-2xl p-6 flex flex-col gap-4">
              <div className="flex items-center justify-between">
                <div className="flex gap-0.5">
                  {[...Array(r.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm" />
                  ))}
                </div>
                <span className={`text-xs font-rounded font-bold px-3 py-1 rounded-full ${
                  r.source === 'google' ? 'bg-kiln/10 text-kiln' : 'bg-tankan/10 text-tankan'
                }`}>
                  {r.source === 'google' ? 'Google' : 'Instagram'}
                </span>
              </div>
              <p className="text-kiln/85 font-rounded text-sm leading-relaxed flex-1">{r.text}</p>
              <div className="flex items-center gap-3 pt-3 border-t border-cream-dark">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 ${r.color}`}>
                  <i className="ri-emotion-happy-line text-xl" />
                </div>
                <div>
                  <p className="text-kiln font-rounded font-bold text-sm">{r.name}</p>
                  <p className="text-kiln/60 text-xs font-rounded">{r.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}